import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=dfc31438"
import script from "./connection.js?vue&type=script&lang=js&external"
export * from "./connection.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports